import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
  putRequest
} from 'utils/http'

export const getDevPlanApi = userId => {
  return getRequest(
    `/development-plans/user/${userId}?filter=this-week
    `
  )
}

export const getStats = query => {
  const { queryKey } = query
  return getRequest(
    `/development-plans/statistics/${
      queryKey[1].userId
    }?filter=${queryKey[1].filterData || 'this-week'}`
  )
}

export const editStepsApi = ({ userId, payload }) => {
  return putRequest(`/development-plans/user/${userId}`, payload)
}

export const deletePlanGoalApi = ({ planId, userId }) => {
  return deleteRequest(
    `/development-plans/user/${userId}/goals/${planId}`
  )
}

export const addPlanGoalApi = ({ userId, payload }) => {
  return postRequest(
    `/development-plans/user/${userId}/goals`,
    payload
  )
}

export const editStepRateApi = ({
  userId,
  planId,
  stepId,
  payload
}) => {
  const { rate } = payload
  return putRequest(
    `/development-plans/user/${userId}/goals/${planId}/action-steps/${stepId}/rate`,
    { rate: rate === null ? null : Number(rate) }
  )
}

export const reorderGoalsApi = ({ userId, orderedGoalIds }) => {
  return putRequest(
    `/development-plans/user/${userId}/goals/reorder`,
    { orderedGoalIds }
  )
}

export const editPlanGoalApi = async ({
  userId,
  planId,
  payload
}) => {
  const {
    title,
    addedSteps,
    editedSteps,
    deletedSteps,
    orderedStepIds = []
  } = payload

  // Apply edits and deletes first.
  await Promise.all([
    ...editedSteps.map(step =>
      putRequest(
        `/development-plans/user/${userId}/goals/${planId}/action-steps/${step.id}`,
        { description: step.description }
      )
    ),
    ...deletedSteps.map(step =>
      patchRequest(
        `/development-plans/user/${userId}/goals/${planId}/action-steps/${step.id}/delete`
      )
    )
  ])

  await putRequest(
    `/development-plans/user/${userId}/goals/${planId}`,
    { title }
  )

  // Create new steps, then map their temporary client ids to the real ids.
  const tempToRealId = {}
  if (addedSteps.length) {
    const addResponse = await postRequest(
      `/development-plans/user/${userId}/goals/${planId}/action-steps/`,
      { actionSteps: addedSteps.map(step => step.description) }
    )
    const createdSteps = addResponse?.actionSteps || []
    addedSteps.forEach((step, index) => {
      if (createdSteps[index])
        tempToRealId[step.id] = createdSteps[index].id
    })
  }

  // Persist the final display order using real ids.
  if (orderedStepIds.length) {
    const orderedActionStepIds = orderedStepIds.map(id =>
      tempToRealId[id] != null ? tempToRealId[id] : id
    )
    await putRequest(
      `/development-plans/user/${userId}/goals/${planId}/action-steps/reorder`,
      { orderedActionStepIds }
    )
  }

  return { success: true }
}
